export const deckInstallationMaterials = [
  {
    groupName: 'Site Prep & Foundation Materials',
    materials: [
      { intent: 'Concrete mix', quantity: 1 },
      { intent: 'Gravel', quantity: 1 },
      { intent: 'Post anchors or brackets', quantity: 1 },
      { intent: 'Hardware for anchor-to-post connections (lag screws, bolts)', quantity: 1 }
    ]
  },
  {
    groupName: 'Framing Materials',
    materials: [
      { intent: 'Pressure-treated lumber or steel posts (4x4, 6x6)', quantity: 1 },
      { intent: 'Pressure-treated lumber or steel beams (2x10, 2x12, LVL, etc.)', quantity: 1 },
      { intent: 'Joists (2x8, 2x10, depending on span)', quantity: 1 },
      { intent: 'Rim joists', quantity: 1 },
      { intent: 'Joist hangers', quantity: 1 },
      { intent: 'Hurricane ties (if needed)', quantity: 1 }
    ]
  },
  {
    groupName: 'Decking Materials',
    materials: [
      { intent: 'Deck boards (composite or wood, based on client selection)', quantity: 1 },
      { intent: 'Fascia boards', quantity: 1 },
      { intent: 'Trim pieces (skirting or lattice)', quantity: 1 }
    ]
  },
  {
    groupName: 'Railing System',
    materials: [
      { intent: 'Railing posts (wood, composite, or metal)', quantity: 1 },
      { intent: 'Post sleeves (if using composite railing)', quantity: 1 },
      { intent: 'Top and bottom rails', quantity: 1 },
      { intent: 'Balusters or infill panels (metal, cable, or composite)', quantity: 1 },
      { intent: 'Railing connectors and brackets', quantity: 1 },
      { intent: 'Cap rail', quantity: 1 },
      { intent: 'ADA-compliant handrail (if required)', quantity: 1 }
    ]
  },
  {
    groupName: 'Stair Materials',
    materials: [
      { intent: 'Stringers', quantity: 1 },
      { intent: 'Treads (matching deck boards)', quantity: 1 },
      { intent: 'Risers (optional or code-specific)', quantity: 1 },
      { intent: 'Stair brackets', quantity: 1 },
      { intent: 'Gravel or pavers for base of stairs', quantity: 1 },
      { intent: 'Concrete pad or landing blocks (if required)', quantity: 1 },
      { intent: 'Stair railing components (matching main rail system)', quantity: 1 }
    ]
  },
  {
    groupName: 'Flashing & Moisture Protection',
    materials: [
      { intent: 'Ledger flashing (metal or PVC)', quantity: 1 },
      { intent: 'Butyl joist tape (optional, for extending framing life)', quantity: 1 },
      { intent: 'Waterproof membrane (if over living space or waterproof deck)', quantity: 1 },
      { intent: 'Foam or backer rod (for sealing gaps)', quantity: 1 }
    ]
  },
  {
    groupName: 'Finishing Materials',
    materials: [
      { intent: 'Wood sealer or stain (for pressure-treated or cedar decks)', quantity: 1 },
      { intent: 'Composite deck cleaner (for final wipe-down)', quantity: 1 },
      { intent: 'Touch-up kit (for composite scratches or scuffs)', quantity: 1 },
      { intent: 'Paint or stain for railing/posts (if wood)', quantity: 1 },
      { intent: 'Furniture pads or glides (optional client add-on)', quantity: 1 }
    ]
  },
  {
    groupName: 'Loadout List - Double Check Your Stock',
    materials: [
      { intent: 'Marking paint or string line', quantity: 1 },
      { intent: 'Stakes & batter boards', quantity: 1 },
      { intent: 'Footing forms', quantity: 1 },
      { intent: 'Post depth marking tags (some inspectors require these during pour)', quantity: 1 },
      { intent: 'Temporary railing (if required during build)', quantity: 1 },
      { intent: 'Safety signage or fencing (if jobsite needs securing)', quantity: 1 },
      { intent: 'Structural screws or nails (galvanized or stainless steel)', quantity: 1 },
      { intent: 'Construction adhesive (optional)', quantity: 1 },
      { intent: 'Beam-to-post hardware (metal brackets, thru-bolts, washers)', quantity: 1 },
      { intent: 'Hidden fasteners or deck screws (color-matched if visible)', quantity: 1 },
      { intent: 'End sealing solution (for wood decks)', quantity: 1 },
      { intent: 'Spacers (if not using hidden fasteners)', quantity: 1 },
      { intent: 'Railing screws or clips', quantity: 1 },
      { intent: 'Caulk or sealant (UV- and weather-resistant)', quantity: 1 },
      { intent: 'Washers & nuts (for all thru-bolts)', quantity: 1 },
      { intent: 'Concrete anchors (if attaching to slab or foundation)', quantity: 1 }
    ]
  }
];
